/**
 * Alberath Background Rotation Hook
 *
 * Returns the login background image URL using Asset system.
 * Uses preloaded blobUrl if available, otherwise falls back to direct URL.
 *
 * NOTE: Background 'bg.login' is preloaded in theme.json at app startup.
 */

import { Asset } from '@rts';

/**
 * Custom hook that returns the login background image URL
 *
 * @returns {string} URL to the login background image (blobUrl if preloaded)
 *
 * @example
 * const backgroundImage = useBackgroundRotation();
 * // Returns: 'blob:...' (if preloaded) or '/alberath/theme/base/images/bg/login.webp'
 */
export function useBackgroundRotation() {
  // Use Asset.img() for preloaded blobUrl (faster)
  if (Asset.isLoaded()) {
    return Asset.img('bg.login');
  }

  // Fallback before Asset is initialized (pre-login)
  const brand = import.meta.env.VITE_GAME_BRAND;
  return `/${brand}/theme/base/images/bg/login.webp`;
}
